import { gql } from '@apollo/client';
import ORDER_ITEM_PROVISIONING_RESULT from './order-item-provisioning-result';

const PROVISIONING_RESULT = gql`
  fragment BaseProvisioningResultFragment on ProvisioningResult {
    success {
      ...BaseOrderItemProvisioningResultFragment
    }
    fail {
      ...BaseOrderItemProvisioningResultFragment
    }
  }
  ${ORDER_ITEM_PROVISIONING_RESULT}
`;

export default PROVISIONING_RESULT;
